import { slices } from "@/constants/sliceNames";
import { Dataset } from "@/entities/Dataset";
import { createSlice } from "@reduxjs/toolkit";

import {
  requestMyDatasetsStatus,
  requestDeleteDatasetStatus,
  requestAddFavoriteDatasetStatus,
  requestSingleDatasetStatus,
  requestSingleSensorStatus,
  requestTimeDataStatus,
  requestUpdateDatasetStatus,
  requestLabelDatasetStatus,
} from "../effects/datasets-effects";

const initialState = {
  datasets: [],
  dataset: new Dataset(),
  loading: false,
  message: "",
  records_count: 0,
  timeData: [],
};

const datasetListSlice = createSlice({
  name: slices.datasets,
  initialState,
  reducers: {
    resetDatasets: () => initialState,
  },
  extraReducers: {
    ...requestMyDatasetsStatus,
    ...requestDeleteDatasetStatus,
    ...requestAddFavoriteDatasetStatus,
    ...requestSingleDatasetStatus,
    ...requestSingleSensorStatus,
    ...requestTimeDataStatus,
    ...requestUpdateDatasetStatus,
    ...requestLabelDatasetStatus,
  },
});

const { actions, reducer } = datasetListSlice;
const { resetDatasets } = actions;
export { actions, initialState, resetDatasets };

export default reducer;
